import create from 'zustand';
import produce from 'immer';

import DayJs from 'utils/Dayjs';

const STUDENT_SUBJECT_INITIAL = {
	active: [],
	subjects: [],

	grades: [],
	selected: 0
};

export const useStudentSubjectStore = create(set => ({
	...STUDENT_SUBJECT_INITIAL,

	// Set selected grade
	onSelect: (id) => set(produce(state => {
		state.selected = id;
	})),

	// Initialize student's grade state
	onInit: ({ grades, courses }) => set(produce(state => {
		// Get today's date
		const today = DayJs();

		// Find currently active grade or last assigned grade
		const grade = grades.find(g => ['active'].includes(g.state));	
		const last = [...grades].pop();
		state.selected = grade?.id || last?.id || 0;

		// Filter out currently active grade's subjects
		state.subjects = courses?.reduce((result, course) => {
			return result.some(subject => subject.id === course.subject.id) || course.gradeId !== state.selected
				? result
				: [...result, course.subject];
		}, [])?.sort((a, b) => a.order - b.order);

		// Map active subjects based on courses
		state.active = courses?.filter(course => {
			return DayJs(course.startDate).isBefore(today) && DayJs(course.endDate).isAfter(today);
		})?.reduce((result, course) => {
			return result.some(subject => subject.id === course.subject.id) || course.gradeId !== state.selected
				? result
				: [...result, course.subject];
		}, [])?.sort((a, b) => a.order - b.order);

		// Map subjects for each grade
		state.grades = grades.map(grade => {
			const subjects = courses?.reduce((result, course) => {
				return result.some(subject => subject.id === course.subject.id) || course.gradeId !== grade.id
					? result
					: [...result, course.subject];
			}, [])?.sort((a, b) => a.order - b.order);
			return {
				...grade,
				subjects
			};
		});
	})),

	// Reset store to initial state
	onReset: () => set({
		...STUDENT_SUBJECT_INITIAL
	})
}));